import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

export const LANGUAGES = [
  { code: "en", label: "English", native: "English", dir: "ltr" },
  { code: "de", label: "German", native: "Deutsch", dir: "ltr" },
  { code: "fr", label: "French", native: "Français", dir: "ltr" },
  { code: "es", label: "Spanish", native: "Español", dir: "ltr" },
  { code: "it", label: "Italian", native: "Italiano", dir: "ltr" },
  { code: "nl", label: "Dutch", native: "Nederlands", dir: "ltr" },
  { code: "pt", label: "Portuguese", native: "Português", dir: "ltr" },
  { code: "hi", label: "Hindi", native: "हिन्दी", dir: "ltr" },
  { code: "ar", label: "Arabic", native: "العربية", dir: "rtl" },
  { code: "zh", label: "Chinese", native: "中文", dir: "ltr" },
  { code: "ja", label: "Japanese", native: "日本語", dir: "ltr" },
  { code: "ko", label: "Korean", native: "한국어", dir: "ltr" },
];

export const SUPPORTED = LANGUAGES.map((l) => l.code);
export const dirFor = (code) =>
  LANGUAGES.find((l) => l.code === code)?.dir || "ltr";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED,
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    backend: { loadPath: "/locales/{{lng}}/translation.json" },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

// IP/location fallback — runs only when the visitor has NO stored choice and
// none of their browser languages match a supported language.
export async function ipLanguageFallback() {
  try {
    if (localStorage.getItem("i18nextLng")) return;
    const navLangs = (navigator.languages || [navigator.language || ""]).map((l) =>
      l.slice(0, 2).toLowerCase()
    );
    if (navLangs.some((l) => SUPPORTED.includes(l))) return;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 3000);
    const res = await fetch("https://ipapi.co/json/", { signal: controller.signal });
    clearTimeout(timer);
    if (!res.ok) return;
    const data = await res.json();
    const langs = (data.languages || "")
      .split(",")
      .map((l) => l.slice(0, 2).toLowerCase());
    const hit = langs.find((l) => SUPPORTED.includes(l));
    if (hit) i18n.changeLanguage(hit);
  } catch (_) {
    /* best-effort; silently ignore */
  }
}

export default i18n;
